export const FIELD_REQUIRED_MESSAGE = 'Field is required';
export const ENDDATETIME_FIELD_AFTER_STARTDATE_MESSAGE = 'Date should be after start date';
export const NUMBER_REQUIRED_MESSAGE = 'Must be a number';
export const CANNOT_BE_NEGATIVE_NUMBER_MESSAGE = 'Cannot be a negative number';
